<template>
    <div class="file-uploader-container">    
        <FileUploadSteps 
            :folderUuid="this.$route.params.id"
            :folderId="this.$route.params.folderid"
        />
    </div>
</template>

<script>
import FileUploadSteps from '../../components/app/file_upload_components/FileUploadSteps.vue';

export default {
    components: {
        FileUploadSteps
    }
}
</script>

<style>

</style>
